import React from "react";
import {
  AWAITING_RESPONDANT,
  RESPONDANT_ONBOARDED,
  NEGOTIATION_ONGOING,
  NEGOTIATION_REACHED,
  NEGOTIATION_QUIT_BY_CLAIMENT,
  NEGOTIATION_QUIT_BY_RESPONDENT,
  CLAIMENT_PAID_NEGOTIATION,
  BOTH_PAID_NEGOTIATION,
  RESPONDENT_PAID_NEGOTIATION,
  NEGOTIATION_QUIT_BY_CASEMANAGER,
  AWAITING_RESPONDANT_QUIT,
} from "../../../helpers/constants";
import CommentBox from "./common/CommentBox";
import CaseAgreement from "./common/CaseAgreement";
import AgreementDocCard from "./common/AgreementDocCard";
import _ from "lodash";

const HIDE_COMMENT_STATES = [
  "awaitingRespondentAcceptance",
  "noticeToArbitrate",
  "arbitrationReferenced",
  "arbitrationNominated",
  "arbitrationConfirmed",
  "waitingForArbitratorConfirmation",
  "firstNoticeSent",
  "statementOfClaimFiled",
  "awaitingForSec17Details",
  "sec17PetitionFiled",
  "sec17Ordered",
  "awaitingSec17Execution",
  "sec17ExtensionMemoFiled",
  "sec17ExtensionMemoOrdered",
  "fsOrdered",
  "attachmentOrdered",
  "garnisheeProhibitaryOrder",
  "garnisheeFinalOrder",
  "sec17Closed",
  "statementOfDefenceFiled",
  "rejoinderFromClaimant",
  "surrejoinderFromRespondent",
  "2ndNoticeMOM",
  "evidenceFiledByClaimant",
  "evidenceFiledByRespondent",
  "crossExamination",
  "argumentsByClaimant",
  "argumentsByRespondent",
  "negotiationOngoing",
  "firstHearing",
  "secondHearing",
  "thirdHearing",
  "firstMom",
  "arbitrationInprogress",
  "commencementLetter",
  "referenceLetter",
];

const STATE_CONFIGS = {
  [AWAITING_RESPONDANT]: {
    errorText: "Respondent Declined the Case",
    status: (caseDetails) =>
      caseDetails.respondentStatus === "declined" ? "error" : undefined,
    expand: true,
  },
  [AWAITING_RESPONDANT_QUIT]: {
    errorText: "Case Closed by Scrutiny Clerk",
    status: "error",
    expand: true,
    disabled: true,
  },
  [RESPONDANT_ONBOARDED]: {
    errorText: "Respondent Declined the Case",
    status: (caseDetails) =>
      caseDetails.respondentStatus === "declined" ? "error" : undefined,
    expand: true,
  },
  [NEGOTIATION_ONGOING]: { expand: true },
  [NEGOTIATION_QUIT_BY_CLAIMENT]: {
    errorText: "Case Quit by Claimant",
    status: "error",
    expand: true,
    disabled: true,
  },
  [NEGOTIATION_QUIT_BY_RESPONDENT]: {
    errorText: "Case Quit by Respondent",
    status: "error",
    expand: true,
    disabled: true,
  },
  [NEGOTIATION_QUIT_BY_CASEMANAGER]: {
    errorText: "Case Closed by Scrutiny Clerk",
    status: "error",
    expand: true,
    disabled: true,
  },
  [NEGOTIATION_REACHED]: { expand: true, disabled: true },
  [CLAIMENT_PAID_NEGOTIATION]: {
    expand: false,
    disabled: true,
    showAgreement: true,
  },
  [RESPONDENT_PAID_NEGOTIATION]: {
    expand: false,
    disabled: true,
    showAgreement: true,
  },
  [BOTH_PAID_NEGOTIATION]: {
    expand: false,
    disabled: true,
    showAgreement: true,
  },
  reservedForAward: { expand: false, showAgreement: true },
  awardPassed: { expand: false, showAgreement: true },
  resolutionFailed: { expand: false },
  settledAndWithdrawn: { expand: false, showAgreement: true },
  updatedAndWithdrawn: { expand: false, showAgreement: true },
  finalAward: { expand: false, disabled: true, showAgreement: true },
};

const DEFAULT_STATE = {
  expand: true,
  disabled: false,
  showAgreement: false,
};

function MediationState({
  currentState,
  isRespondent,
  ownerId,
  caseDetails,
  comments,
  setComments,
  partyList = [],
  isLocalTranscriptionServer,
}) {
  const renderCommentBox = (config) => (
    <CommentBox
      title={`${_.capitalize(caseDetails?.resolutionKind)} Process`}
      expand={config.expand}
      status={
        typeof config.status === "function"
          ? config.status(caseDetails)
          : config.status
      }
      errorText={config.errorText}
      ownerId={ownerId}
      caseId={caseDetails?.id}
      comments={comments}
      disabled={config.disabled}
      setComments={setComments}
      hideAddComment={HIDE_COMMENT_STATES.includes(currentState?.key)}
      partyList={partyList}
      isLocalTranscriptionServer={isLocalTranscriptionServer}
      kind={
        caseDetails?.resolutionKind === "mediation" ? "Mediator" : "Arbitrator"
      }
    />
  );

  const AgreementSection = () => (
    <>
      <div className="mt-7">
        <CaseAgreement
          title={`Final Award Summary for Case ID: ${caseDetails?.id}`}
          message={caseDetails?.negotiationSummary}
          summaryStatus={caseDetails?.summaryStatus === "completed"}
          isPaid={currentState?.cta?.length === 0}
        />
      </div>
      <div className="mt-7">
        <AgreementDocCard
          id={caseDetails?.id}
          status={caseDetails.status}
          isRespondent={isRespondent}
          hasRating={caseDetails?.rating}
          hasAgreement={caseDetails?.hasAgreementDocument}
          type="Download"
        />
      </div>
    </>
  );

  const config = {
    ...DEFAULT_STATE,
    ...(STATE_CONFIGS[currentState?.key] || {}),
  };

  // Handle default case for arbitration-related states
  if (
    !STATE_CONFIGS[currentState?.key] &&
    HIDE_COMMENT_STATES.includes(currentState?.key)
  ) {
    config.expand = true;
  }

  return (
    <div className="mt-7">
      {renderCommentBox(config)}
      {config.showAgreement && <AgreementSection />}
    </div>
  );
}

export default React.memo(MediationState);
